/**
 * In-memory preview draft staged when navigating editor → preview before
 * ws-collaboration persists a new report_versions row (~10s debounce).
 */

/**
 * @typedef {Object} PreviewDraft
 * @property {string} reportId
 * @property {object} content - ProseMirror JSON (type: doc)
 * @property {Array} references
 * @property {Object|null} metadata - document header fields from Y.Map documentMeta
 * @property {Array|null} authors - resolved author badges staged from editor content
 * @property {number} stagedAt
 */

/**
 * @param {PreviewDraft|null|undefined} draft
 * @param {string} reportId
 */
export function hasActivePreviewDraft(draft, reportId) {
    return Boolean(draft?.content && reportId && draft.reportId === String(reportId));
}

/**
 * Resolve which version blob to load. When opening preview from the editor we stage
 * a draft before the URL catches up — treat that as latest immediately.
 *
 * @param {string|null|undefined} urlVersion
 * @param {PreviewDraft|null|undefined} draft
 * @param {string} reportId
 * @param {string|number|null|undefined} latestVersion
 * @returns {string|null}
 */
export function resolvePreviewVersion(urlVersion, draft, reportId, latestVersion) {
    if (urlVersion) {
        return String(urlVersion);
    }
    if (hasActivePreviewDraft(draft, reportId) && latestVersion != null) {
        return String(latestVersion);
    }
    return null;
}

/**
 * @param {PreviewDraft|null|undefined} draft
 * @param {string} reportId
 * @param {string|number|null|undefined} version
 * @param {string|number|null|undefined} latestVersion
 */
export function shouldUsePreviewDraft(draft, reportId, version, latestVersion) {
    if (!hasActivePreviewDraft(draft, reportId)) {
        return false;
    }
    if (!latestVersion || version == null) {
        return false;
    }
    return String(version) === String(latestVersion);
}
